import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

// data = { paymentTypes: number[] }
export const setPaymentTypes = async ({ requestId, data }) => {
  return request.put(
    `/Request/set_payment_type/${requestId}`,
    data,
    `Не удалось установить выбранные способы оплаты`,
    'Error'
  );
};

export const useSetPaymentTypes = (options = {}) => {
  const paymentTypesMutation = useMutation(setPaymentTypes, {
    ...options,
    onSuccess: async (res, { requestId }) => {
      if (res !== 'Error' && typeof options.onSuccess === 'function') {
        await options.onSuccess({ requestId, res });
      }
    },
  });

  return {
    setAsync: paymentTypesMutation.mutateAsync,
    set: paymentTypesMutation.mutate,
    loading: paymentTypesMutation.isLoading,
  };
};
